import type { DataMode } from './dataMode'

/**
 * When a fixture's result becomes visible.
 *
 * `resultsRevealed` is one boolean for a whole gameweek. That is not what a Saturday looks like:
 * results land one match at a time from 12:30 to 22:00, and a match that ends at 17:20 should
 * reveal at 17:20 — not when the 20:00 kickoff finishes.
 *
 * `/api/results` returns **only `finished` fixtures**, so against real football "we have a result
 * for this fixture" *is* "this fixture has finished", and every reveal site already guards on the
 * result being present. So it collapses to one question: may a present result reveal itself, or
 * must it wait for the gameweek flag?
 *
 * In `mock` it must wait. The bundled season is 380 already-final scorelines loaded at boot, so
 * every result is present from the first render and self-revealing would show the whole season
 * immediately; there the dev tools' gameweek flag stays the only answer, exactly as today. In
 * `replica` and `live` the fixture's own status is the honest one, and the flag remains as the
 * gameweek-level override.
 *
 * `null` — the mode before `/api/me` has landed — is treated as `mock`: the conservative side, and
 * the bootstrap has not painted anything yet anyway.
 */
export function areResultsVisible(resultsRevealed: boolean, mode: DataMode | null): boolean {
  return resultsRevealed || mode === 'replica' || mode === 'live'
}
